import type { ReactNode } from 'react';

/** El resumen de «A quién le aplica» en una línea, con el mismo peso en todos los editores. */
export function AudienceSummary({ children }: { children: ReactNode }) {
    return <b className="font-semibold text-foreground">{children}</b>;
}
